module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"review_button_title":"打开详细评价弹窗"}}')
  delete Component.options._Ctor
}
